module.exports = __webpack_public_path__ + "img/megafon.e207b298.svg";